import { Link } from 'react-router-dom'
import { Panel } from '../../../components/Panel'
import { DeskFrame } from './DeskFrame'
import { useDeskState } from './useDeskState'
import { VisitorsRevenueBody } from '../VisitorsRevenueBody'
import { revenueRange } from '../../../lib/deskPeriod'
import { DESK_PUBS, deskPath } from '../../../lib/deskTabs'
import { pubLabel } from '../../../lib/deskFormat'
import { rangeToSearch, todayEastern } from '../../../lib/visitorsRange'

function Body() {
  const { pub, q, search } = useDeskState('revenue')
  const range = revenueRange(q, todayEastern())
  if (pub === 'all') {
    return (
      <Panel accent="none">
        <p className="text-paper">Revenue is read one title at a time.</p>
        <p className="mt-2 flex flex-wrap gap-4 font-mono text-[12px]">
          {DESK_PUBS.filter((p) => p !== 'all').map((p) => (
            <Link key={p} to={deskPath(p, 'revenue', search)} className="text-amber-glow hover:underline">{pubLabel(p)}</Link>
          ))}
        </p>
      </Panel>
    )
  }
  return <VisitorsRevenueBody pub={pub} range={range} search={new URLSearchParams(rangeToSearch(range)).toString()} />
}

export function DeskRevenue() {
  return <DeskFrame tab="revenue"><Body /></DeskFrame>
}
